export default __webpack_public_path__ + "static/media/Productspage.b187a0d7.png";